import { useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Card from '@/components/card/card-component';
import PageWrapper from '@/components/page-wrapper/page-wrapper-component';
import { TableHeadersText } from '@/utils/global-fonts';
import InfoModal from '../sales-flow/components/configuration/config-components/info-modal';
import CategorySummary from '../company-management/category-summary/category-summary';
import { SUMMARY_CONTEXT } from './context-provider';
import Styled from './summary-style';

/**
 * Page that shows the Summary
 * @returns {JSX.Element} The rendered Summary page component.
 */
const Summary = () => {
  const [infoModalAction, setInfoModalAction] = useState({
    show: false,
    node: null,
  });
  const { summary } = useContext(SUMMARY_CONTEXT);
  const { state } = useLocation();

  const navigate = useNavigate();

  const groupedOptionsByName = summary?.quote_options?.reduce((acc, item) => {
    if (!acc[item.name]) {
      acc[item.name] = [];
    }
    acc[item.name].push(item);
    return acc;
  }, {});

  const closeInfoModal = () => {
    setInfoModalAction({ show: false, node: null });
  };

  const navigateToConfigure = () => {
    navigate('/shop/sales/configuration', { state });
  };

  return (
    <PageWrapper>
      <Card margin="24px 0 0 0">
        <Styled.Header>
          <Styled.HeaderRow>
            <Styled.HeaderCol sm={6} md={6} lg={6} xl={6} xxl={6}>
              <TableHeadersText>DESCRIPTION</TableHeadersText>
            </Styled.HeaderCol>
            <Styled.HeaderCol sm={3} md={3} lg={3} xl={3} xxl={3}>
              <TableHeadersText>PART NO.</TableHeadersText>
            </Styled.HeaderCol>
            <Styled.HeaderCol sm={3} md={3} lg={3} xl={3} xxl={3}>
              <TableHeadersText>ACTION</TableHeadersText>
            </Styled.HeaderCol>
            <Styled.GreyLine />
          </Styled.HeaderRow>
        </Styled.Header>
        {groupedOptionsByName &&
          Object?.keys(groupedOptionsByName)?.map((key) => (
            <CategorySummary
              key={key}
              heading={key}
              onAction={navigateToConfigure}
              onInfo={() =>
                setInfoModalAction({
                  node: groupedOptionsByName[key][0],
                  show: true,
                })
              }
              data={groupedOptionsByName[key].map((option) => ({
                id: option?.id,
                title: option?.name,
                image: option?.option_price_link_thumbnail || option?.thumbnail,
                description: option?.price_name,
                partNumber: option?.part_number,
                belowTheLine: option?.below_the_line,
              }))}
            />
          ))}
      </Card>

      <InfoModal
        id={infoModalAction?.node?.option_price_link_id}
        open={infoModalAction.show}
        close={closeInfoModal}
        showPrimaryButton={false}
      />
    </PageWrapper>
  );
};

export default Summary;
